module.exports = __webpack_public_path__ + "img/097-san-marino.9f7a149d.svg";